export class TypeCPVClassFNSSimple {

	public classPrincipale: string;

	constructor() { 
		 		this.classPrincipale = '';
 
	}
}
